import Hero from '../component/Hero';
import Services from '../component/Services';
import 'aos/dist/aos.css';
import WarehouseImpactSection from '../component/WarehouseImpactSection';
// import '../Homepages/Secondpage.css';
import Contact from '../component/Contact';
import Ourvision from '../component/Ourvision';
import ReasonForUtilisation from '../component/ReasonForUtilisation';
import Home from '../component/Home';
import Management from '../component/Management';

function Landing() {
    return (
        <div>
            <Hero />
            <Services />
            <Home />
            <WarehouseImpactSection />
            <Management />
            <ReasonForUtilisation />
            <Ourvision />
            <Contact />
        </div>
    )
}


export default Landing